import Page from "../../../../material/skeleton/Page";
import Header from "../../../../material/skeleton/Header";
import {useParams} from "react-router";
import {useEffect, useRef, useState} from "react";
import isNull from "../../../../mixin/isNull";
import useInterventionRepository from "../../../../repository/insurance/useInterventionRepository";
import useOrderRepository from "../../../../repository/insurance/useOrderRepository";
import useClientRepository from "../../../../repository/insurance/useClientRepository";
import LoadingData from "../emergency/step/common/LoadingData";
import Menu from "./Menu";
import StepWrapper from "./StepWrapper";
import {Chip, Link} from "@mui/material";
import {Help} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Modal from "../../../../material/modal/Modal";
import ModalConfig from "../../../../material/modal/ModalConfig";
import OrderData from "./OrderData";
import useAxiosConfigHeader from "../../../../use/useAxiosConfigHeader";

export default function () {
    const {token} = useParams();
    const headerConfigured = useAxiosConfigHeader("insurance", token);
    const interventionRepository = useInterventionRepository();
    const orderRepository = useOrderRepository();
    const clientRepository = useClientRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(intervention?.getOrderId()).select();
    /** @type Client */
    const client = clientRepository.findOneById(order?.getClientId()).select();
    const [updateQuotation, setUpdateQuotation] = useState(false);
    const [openOrderData, setOpenOrderData] = useState(false);
    const helpLink = useRef();

    useEffect(() => {
        if (!headerConfigured) return;

        interventionRepository.findOneByToken(token).exec();
    }, [headerConfigured]);

    useEffect(() => {
        interventionRepository.findOneByToken(token).exec();
    }, []);

    useEffect(() => {
        if (isNull(intervention)) return;

        orderRepository.findOneById(intervention.getOrderId()).exec();
    }, [JSON.stringify(intervention)]);

    useEffect(() => {
        if (isNull(order)) return;

        clientRepository.findOneById(order.getClientId()).exec();
    }, [JSON.stringify(order)]);

    const toggleUpdateQuotation = o => () => setUpdateQuotation(o);
    const toggleOpenOrderData = o => () => setOpenOrderData(o);

    const handleHelp = () => helpLink.current.click();

    if (isNull(intervention) || isNull(order) || isNull(client)) return <LoadingData/>;

    return (
        <Page>
            <Header>
                <Menu
                    orderId={order.getId()}
                    interventionId={intervention.getId()}
                    clientId={client.getId()}
                    onUpdateQuotation={toggleUpdateQuotation(true)}
                    onOpenOrderData={toggleOpenOrderData(true)}
                    updateQuotation={updateQuotation}
                />
            </Header>

            <StepWrapper
                interventionId={intervention.getId()}
                clientId={client.getId()}
                orderId={order.getId()}
                updateQuotation={updateQuotation}
                onQuotationUpdated={toggleUpdateQuotation(false)}
            />

            <Box position="fixed" bottom={60} right={10} onClick={handleHelp}>
                <Chip icon={<Help/>} label={"Assistant"} color={"warning"}/>
            </Box>

            {
                openOrderData
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("100%")
                                    .setOnClose(toggleOpenOrderData(false))
                                    .setComponent(<OrderData orderId={order.getId()}/>)
                            }
                        />
                    )
                    : null
            }

            <Link
                ref={helpLink}
                visibility={"hidden"}
                href={`tel:${process.env.REACT_APP_FFG_PHONE_NUMBER}`}
                underline={"none"}
                color={"inherit"}
            />
        </Page>
    )
}
